import MoneyJson from './interfaces/MoneyJson'

export default class Money {
  amount: number
  currency: string

  constructor(amount: number, currency: string) {
    this.amount = amount
    this.currency = currency
  }

  toString(locale: string) {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      currency: this.currency,
    }).format(this.amount)
  }

  static fromJson(data: MoneyJson) {
    return new this(Number(data.amount), data.currency)
  }

  toJson(): MoneyJson {
    return {
      amount: String(this.amount),
      currency: this.currency,
    }
  }
}
